import React, { useContext } from "react";
import { DataContext } from "../../../context/DataContext";
import IDMatchEdge from "./coppa-edge";
import IDMatchLegacy from "./coppa-legacy";

export default function IDMatch() {
  const { data } = useContext(DataContext);

  // If edge mode is enabled, use the edge version with progressive fields
  // Otherwise, use the legacy version that shows all fields at once
  if (data?.edge === true) {
    return <IDMatchEdge />;
  }

  return <IDMatchLegacy />;
}
